
// Кнопки "Оплатить" и "Подтвердить" должны отображаться для определенного метода оплаты
// Функция отображает нужную кнопку для выбранного метода оплаты
const showBtnFor = function (radioElem) {
  let isForLinkBtn = $(radioElem).find('input').attr('data-for-link-btn');

  if (isForLinkBtn == 'true')
    showPaymentLinkBtn();
  else
    showConfirmBtn();
};

// Кнопки "Оплатить", "Подтвердить"
let paymentLinkBtn = $('#payment-btn');
let confirmBtn = $('#confirm-btn');

// Показать кнопку "Отправить"
const showPaymentLinkBtn = function () {
  confirmBtn.addClass('main-form-btn_center_hidden');
  paymentLinkBtn.removeClass('main-form-btn_center_hidden');
};

// Показать кнопку "Подтвердить"
const showConfirmBtn = function () {
  paymentLinkBtn.addClass('main-form-btn_center_hidden');
  confirmBtn.removeClass('main-form-btn_center_hidden');
};

export { showBtnFor }
